<template>
  <div>
    <template v-if="agreeYn == 'N'">
      <PrivacyPolicy :routeParam="$route.params"></PrivacyPolicy>
    </template>
    <template v-if="agreeYn == 'Y'">
      <div class="grey lighten-4">
        <CVProfileBanner
          ref="profile"
          :isReadonly="isReadonly"
        ></CVProfileBanner>
        <CVSection
          v-if="titles"
          :routeParam="$route.params"
          :obj="template"
          :titles="titles"
          :isReadonly="isReadonly"
          :modifyBlockYn="modifyBlockYn"
        ></CVSection>
      </div>
    </template>
    <BasePopup v-model="passwordPopup" title="비밀번호입력" width="600">
      <template>
        <v-row class="ma-0 pa-0 inner-padding">
          <v-col cols="12" class="pa-0 pt-4 text-center">
            <i-text-field
              v-model="inputPassword"
              type="password"
              prepend-inner-icon="mdi-key"
              :rules="[rules.required, rules.min]"
              label=""
              hint="At least 8 characters"
              class="input-group--focused pa-0 ma-0"
            ></i-text-field>
          </v-col>
        </v-row>
      </template>
      <template #actions="{close}">
        <v-card-actions
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <v-col class="py-0 pr-0">
            <i-btn
              block
              color="#087ef7"
              @click="passwordCheck(close)"
              elevation="0"
            >
              <span class="white--text">{{ $t('확인') }}</span>
            </i-btn>
          </v-col>
        </v-card-actions>
      </template>
    </BasePopup>
  </div>
</template>

<script>
import { getAuthJson } from '@/api/network';

import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import CVProfileBanner from '@/components/items/resume/CVProfileBanner.vue';
import CVSection from '@/components/items/resume/CVSection.vue';

export default {
  components: { PrivacyPolicy, CVProfileBanner, CVSection },
  data: () => ({
    template: null,
    agree: null,
    delimeter: '#',
    titles: null,
    agreeYn: '',
    isReadonly: null,
    modifyBlockYn: 'N',
    passwordPopup: false,
    inputPassword: '',
    email: '',
    rules: {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
    },
    pwAgreeYn: '',
    pwIsReadonly: false,
    pwModifyBlockYn: 'N',
    annoPassword: null,
    annoPassYn: 'N',
  }),
  async beforeCreate() {
    const p = {
      annoId: this.$route.params.annoId,
    };
    /* 중복지원 체크 */
    await getAuthJson(
      'api/v1/' + this.$route.params.tenantKey + '/checkDuplApply',
      p,
    )
      .then(res => {
        if (res.status !== 200) {
          console.log('CUSTOM INFO SAVE FAIL');
        } else {
          if (res.data.status != 'dupl') {
            this.annoPassword = res.data.announce.annoPassword;
            this.annoPassYn = res.data.announce.annoPassYn;
            //동의 여부 확인 후 동의가 안된 경우 동의여부 페이지로 이동하도록
            getAuthJson(
              'api/v1/' + this.$route.params.tenantKey + '/isagree',
              p,
            )
              .then(res => {
                if (res.data && res.status === 200) {
                  if (this.annoPassYn == 'Y' && !res.data.isAgree) {
                    this.pwAgreeYn = res.data.isAgree ? 'Y' : 'N';
                    this.pwIsReadonly = res.data.isReadonly;
                    this.pwModifyBlockYn = res.data.modifyBlockYn || 'N';
                    this.openPopup();
                  } else {
                    this.agreeYn = res.data.isAgree ? 'Y' : 'N';
                    this.isReadonly = res.data.isReadonly;
                    this.modifyBlockYn = res.data.modifyBlockYn || 'N';
                    if ('Y' == this.agreeYn) this.setting();
                  }
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            this.$showAlert(res.data.errorMsg);
            /* 이전 페이지로 이동 */
            this.$router.back();
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    setting: function() {
      const p = { annoId: this.$route.params.annoId };
      getAuthJson('api/v1/' + this.$route.params.tenantKey + '/am/cv/t', p)
        .then(res => {
          if (res && res.data) {
            this.template = res.data;
            this.titles = res.data.typeOrder.split(this.delimeter);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imageValid: function() {
      return this.$refs.profile.imageValid();
    },
    /* 비밀번호 팝업창 */
    openPopup() {
      this.passwordPopup = true;
      this.inputPassword = '';
      this.email = '';
    },
    /* 비밀번호 확인 */
    async passwordCheck(popupClose) {
      if (this.annoPassword == this.inputPassword) {
        this.agreeYn = this.pwAgreeYn;
        this.isReadonly = this.pwIsReadonly;
        this.modifyBlockYn = this.pwModifyBlockYn;

        const p = {
          annoId: this.$route.params.annoId,
        };

        await getAuthJson(
          'api/v1/' + this.$route.params.tenantKey + '/checkApplByPassword',
          p,
        )
          .then(() => {
            popupClose();
          })
          .catch(() => {
            this.$showAlert('해당 공고 대상자가 아닙니다!');
            popupClose();
            this.$router.back();
          });

        console.log('@@' + this.user);
      } else {
        this.$showAlert('비밀번호가 틀렸습니다.');
        this.inputPassword = '';
      }
    },
  },
};
</script>

<style>
/* common */
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}
.icon-wrap {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid #637887;
  border-radius: 4px;
}
.emty-msg {
  font-size: 14px;
  color: #637887 !important;
}

[v-cloak] > * {
  display: none;
}
[v-cloak]::before {
  content: ' ';
  display: block;
  position: absolute;
  width: 80px;
  height: 80px;
  background-image: url(/images/svg/loader.svg);
  background-size: cover;
  left: 50%;
  top: 50%;
}
</style>
